/**
* Convert date in fr-CA string format, i.e yyyy-mm-dd.
*/
export function getInputDate(value: Date): string {
	const date = new Date(value);
	return new Intl.DateTimeFormat('fr-CA').format(date);
}

/**
 * Convert date in string format according to locale language.
 */
export function convertToLocalDate(value: Date | null, UTCMode = true, time = false): string {
	if (!value) return '';
	const date = new Date(value);
	const lang: string = navigator.language;
	let options: Intl.DateTimeFormatOptions = { numberingSystem: 'latn' };
	if (UTCMode) options = { ...options, timeZone: 'UTC' };
	if (time) options = { ...options, day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false };
	const locale = new Intl.DateTimeFormat(lang, options).format(date);
	const raw = locale?.replaceAll('\u200f', ''); // remove rtl escape char
	return raw;
}

/**
* Convert date in ISo format.
*/
export function convertToISOString(date: Date): string {
	const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	const isoString = utcDate.toISOString();
	return isoString;
}




const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

/**
* Convert ISO string in date.
*/
export function parseIsoDateStrToDate(key: string, value: any) {
	if (typeof value === "string" && isoDateFormat.test(value)) {
		return new Date(value);
	}
	return value
}

/**
* Convert json date in object date.
*/
export function revertJsonDate(date: any): any {
	const revertDate = JSON.parse(JSON.stringify(date), parseIsoDateStrToDate);
	return revertDate;
}

let _dateFormat: string | null = null;
export function dateFormat(): string {
	if (_dateFormat) return _dateFormat;
	const refDate = new Date(2025, 10, 23);
	_dateFormat = new Intl.DateTimeFormat(navigator.language, { year: 'numeric', month: '2-digit', day: '2-digit' })
		.formatToParts(refDate)
		.map(({ type, value }) => {
			switch (type) {
				case 'day': return 'dd';
				case 'month': return 'mm';
				case 'year': return 'yyyy';
				default: return value;
			}
		})
		.join('');
	return _dateFormat;
}